import { useThemeStore } from "@/stores/use-theme-store";

export const useTheme = () => {
  const preference = useThemeStore((state) => {
    return state.preference;
  });
  const resolvedTheme = useThemeStore((state) => {
    return state.resolvedTheme;
  });
  const setPreference = useThemeStore((state) => {
    return state.setPreference;
  });

  return { preference, resolvedTheme, setPreference };
};
